import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaYoutube, FaInstagram, FaChevronRight } from 'react-icons/fa';
import '../stylings/Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="container-fluid px-5">
          <div className="row g-4">
            {/* School Info */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-brand">
                <img src={logo} alt="Akash Model School" className="footer-logo" />
                <h4>Akash Model Sr. Sec. School</h4>
                <p className="footer-tagline">Work Is Worship</p>
              </div>
              <p className="footer-about-text">
                Providing quality education since 1991, Akash Model Sr. Sec. School is a CBSE affiliated
                institution committed to the holistic development of every student.
              </p>
              <div className="footer-socials">
                <a href="https://www.facebook.com/akashmodelseniorsecondaryschool" target="_blank" rel="noreferrer"><FaFacebook /></a>
                <a href="https://www.youtube.com/@akashmodelschool2063" target="_blank" rel="noreferrer"><FaYoutube /></a>
                <a href="https://instagram.com/akash_model_sr._sec._school?igshid=NTdlMDg3MTY=" target="_blank" rel="noreferrer"><FaInstagram /></a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6">
              <h5 className="footer-heading">Quick Links</h5>
              <ul className="footer-links">
                <li><FaChevronRight /><Link to="/">Home</Link></li>
                <li><FaChevronRight /><Link to="/about-school">About School</Link></li>
                <li><FaChevronRight /><Link to="/principal-message">Principal's Message</Link></li>
                <li><FaChevronRight /><Link to="/noticeall">Notices</Link></li>
                <li><FaChevronRight /><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>

            {/* Academics */}
            <div className="col-lg-3 col-md-6">
              <h5 className="footer-heading">Academics & Disclosure</h5>
              <ul className="footer-links">
                <li><FaChevronRight /><Link to="/syllabus">Syllabus</Link></li>
                <li><FaChevronRight /><Link to="/time-table">Time Table</Link></li>
                <li><FaChevronRight /><Link to="/galleryall">Photo Gallery</Link></li>
                <li><FaChevronRight /><Link to="/videoall">Video Gallery</Link></li>
                <li><FaChevronRight /><Link to="/cbse-mandatory-public-disclosure">Mandatory Public Disclosure</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6">
              <h5 className="footer-heading">Contact Us</h5>
              <ul className="footer-contact-list">
                <li>
                  <FaMapMarkerAlt className="footer-contact-icon" />
                  <span>Baljeet Vihar, Nithari Extn. Near Rohini Sec-22, New Delhi-110086</span>
                </li>
                <li>
                  <FaPhone className="footer-contact-icon" />
                  <a href="tel:9999355051">9999355051</a>
                </li>
                <li>
                  <FaPhone className="footer-contact-icon" />
                  <a href="tel:9211101997">9211101997</a>
                </li>
                <li>
                  <FaEnvelope className="footer-contact-icon" />
                  <a href="mailto:akashmodelschool5051@gmail.com">akashmodelschool5051@gmail.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container-fluid px-5">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p>© {new Date().getFullYear()} Akash Model Sr. Sec. School. All Rights Reserved.</p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <p>
                Design and Develop by{' '}
                <a href="https://mycampus.co.in/" target="_blank" rel="noreferrer">
                  MyCampus
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
